// lib/swrFetcher.ts
import api from "@/lib/axiosInstance";

export const axiosFetcher = (url: string) =>
  api.get(url).then((res) => res.data);
